import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { PartnerApi } from "../../../../../../../services/Api/Partner/partnerTypes";
import TaxIdNoWithGusInput from "../../../../../components/Admin/TaxIdNoWithGusInput/TaxIdNoWithGusInput";

interface Props {
	form: UseFormReturn<PartnerApi>;
}

const PartnerCompanyDetailsForm = ({ form }: Props) => {
	const {
		register,
		formState: { errors },
	} = form;
	const { t } = useTranslation("admin");

	return (
		<fieldset className="form-group no-gutters">
			<h5>{t("common.word.company_info")}</h5>
			<div className="row">
				<div className={"col-md-6"}>
					<FormInput
						label={t("lib:common.word.name")}
						register={register}
						name="company_name"
						errors={errors}
					/>
				</div>
				<div className={"col-md-6"}>
					<TaxIdNoWithGusInput prefix={"company_"} form={form} name={"company_tax_id_no"} />
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("lib:common.address.city")}
						register={register}
						name="company_city"
						errors={errors}
					/>
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("lib:common.address.zip_code")}
						register={register}
						name="company_zip_code"
						errors={errors}
					/>
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("lib:common.address.street")}
						register={register}
						name="company_street"
						errors={errors}
					/>
				</div>
				<div className="col-md-3">
					<FormInput
						label={t("lib:common.address.build_nr")}
						register={register}
						name="company_build_nr"
						errors={errors}
					/>
				</div>
				<div className="col-md-3">
					<FormInput
						label={t("lib:common.address.flat_nr")}
						register={register}
						name="company_flat_nr"
						errors={errors}
					/>
				</div>
				<div className={"col-md-6"}>
					<FormInput
						label={t("modules.partner.field.contact_person.title")}
						register={register}
						name="contact_person"
						errors={errors}
					/>
				</div>
				<div className={"col-md-6"}>
					<FormInput
						label={t("modules.partner.field.company_email.title")}
						register={register}
						name="company_email"
						errors={errors}
					/>
				</div>
				<div className={"col-md-6"}>
					<FormInput
						label={t("modules.partner.field.company_phone_number.title")}
						register={register}
						name="company_phone_number"
						errors={errors}
					/>
				</div>
			</div>
		</fieldset>
	);
};

export default PartnerCompanyDetailsForm;
